import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { bindActionCreators } from 'redux';
import * as DashboardActions from '../../actions/dashboard_actions';
import * as FacilitiesActions from '../../actions/facilities_actions';
import _ from 'lodash';
import Header from '../../components/header';
import moment from 'moment';
let screenIdentifier = 'moreNotifications';



let MoreNotifications = React.createClass({
    getInitialState() {
        return {
            isDeleting: false,notificationsClicket:false

        }
    },
    componentWillReceiveProps(nextProps) {

            if(this.state.notificationsClicket  ){
              if (nextProps.FacilitiesDetails.FaciliteDetailsByID ? nextProps.FacilitiesDetails.FaciliteDetailsByID.status == 200 : false) {
                  this.setState({notificationsClicket:false});
                  this.props.router.push('/facilities/details');
              }
            }
    },
    componentDidMount() {
        this.props.Dispatch(DashboardActions.notifications());
    },
    openclinic(event){
      
      this.setState({notificationsClicket:true});
      let clinicId = event.target.dataset.clinicid;
      this.props.Dispatch(FacilitiesActions.getAllfacilitiesById(clinicId));
      //this.props.router.push('/facilities/details');
    },
    render() {
        return (
            <div className="row no-margin">

                <div className="col-xs-12 no-padding">
                    <Header screenIdentifier={screenIdentifier} />
                    <div className="dashboard-inner-content">
                    <div className="white-box notification-text">
                        <h3>All Notifications</h3>
                        <ul>
                            <li><span className="ntf-name">Name</span><span className="ntf-role">Role</span><span className="ntf-status">Status</span><span className="ntf-time pull-right">Time</span></li>
                            {_.map(this.props.Notifications, (Data, key) => {
                              let d = new Date(Data.createdDate);
                              let time = moment([d.getFullYear(), d.getMonth(),d.getDate(),d.getHours(),d.getMinutes(),d.getMilliseconds()]).fromNow();
                                return (
                                    <li key={key}  data-clinicID={Data.facility.id} onClick={this.openclinic} ><span data-clinicID={Data.facility.id} className="ntf-name">{Data.firstName} {Data.lastName}</span><span data-clinicID={Data.facility.id} className="ntf-role">{Data.role}</span><span data-clinicID={Data.facility.id} className="ntf-status">{Data.status}</span><span data-clinicID={Data.facility.id} className="pull-right">{time}</span></li>

                                )


                            })
                            }

                        </ul>


                    </div>
                </div>
            </div>
            </div>
        );
    }
});

let mapStateToProps = (state) => {
    return {
        Notifications: state.Dashboard.Notifications,
        FacilitiesDetails: state.Facilites,
    };
};

let mapDispatchToProps = (dispatch) => ({
    DashboardActions: bindActionCreators(DashboardActions, dispatch),
    Dispatch: dispatch
});
export default connect(mapStateToProps,
    mapDispatchToProps)(withRouter(MoreNotifications));



/** WEBPACK FOOTER **
 ** ./src/components/dashboardScreen/moreNotifications.js
 **/